(function () {
function startCoordinator() {
(function () {
  'use strict';

  const SOURCE = 'https://static.klaviyo.com/onsite/js/Wchez4/klaviyo.js?company_id=Wchez4';
  const COMPANY = 'Wchez4';
  const PRIVACY_UI = '#shopify-pc__banner, #shopify-pc__prefs';
  const QUIET_MS = 1200;
  const INITIAL_MS = 200;
  const MAIN_IMAGE_WAIT_MS = 2500;
  const IDLE_WAIT_MS = 400;
  const mobileStartup = typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 760px)').matches;
  const RETRY_MS = [250, 750, 1500, 3000, 6000];
  const bootstrap = document.getElementById('nx-klaviyo-loader-bootstrap');
  if (!bootstrap || bootstrap.dataset.coordinatorStarted === 'true') return;
  bootstrap.dataset.coordinatorStarted = 'true';

  let runtimeStarted = false;
  let runtimeReady = false;
  let productTracked = false;
  let reloading = false;
  let quietTimer = null;
  let retryTimer = null;
  let observer = null;
  let privacyObserver = null;
  let privacyRoots = [];
  let checkFrame = null;
  let retryIndex = 0;
  let apiRequested = false;
  let waitedForPrivacy = false;
  let launchPending = false;
  let mediaCleanup = null;
  let idleHandle = null;
  let idleTimer = null;
  let launchToken = 0;
  let newsletterRequested = false;

  function state(value, reason) {
    bootstrap.dataset.state = value;
    if (reason) bootstrap.dataset.reason = reason;
    else delete bootstrap.dataset.reason;
  }

  function sameCompanyScript() {
    return Array.from(document.scripts).some(function (script) {
      if (!script.src) return false;
      try {
        const url = new URL(script.src, document.baseURI);
        return url.hostname === 'static.klaviyo.com' &&
          /\/onsite\/js\/(?:Wchez4\/)?klaviyo\.js$/.test(url.pathname) &&
          (url.pathname.includes('/Wchez4/') || url.searchParams.get('company_id') === COMPANY);
      } catch (_) {
        return false;
      }
    });
  }

  function visible(element) {
    if (!element || !element.isConnected || element.hidden || element.getClientRects().length === 0) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse';
  }

  function privacyVisible() {
    return Array.from(document.querySelectorAll(PRIVACY_UI)).some(visible);
  }

  function nativePrivacy() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return privacy && typeof privacy.currentVisitorConsent === 'function' &&
      typeof privacy.analyticsProcessingAllowed === 'function' &&
      typeof privacy.marketingAllowed === 'function' ? privacy : null;
  }

  function purposesAllowed() {
    const privacy = nativePrivacy();
    if (!privacy) return false;
    try {
      const consent = privacy.currentVisitorConsent();
      if (consent && (consent.analytics === 'no' || consent.marketing === 'no')) return false;
      return privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
    } catch (_) {
      return false;
    }
  }

  function permissionToStart() {
    if (document.visibilityState === 'hidden') return 'page-hidden';
    if (privacyVisible()) return 'privacy-ui-visible';
    if (!nativePrivacy()) return 'privacy-api-unavailable';
    return purposesAllowed() ? null : 'privacy-purpose-not-allowed';
  }

  function trackProduct() {
    if (productTracked || reloading || !runtimeReady || !purposesAllowed()) return;
    const data = document.getElementById('nx-klaviyo-product');
    if (!data) return;
    try {
      const item = JSON.parse(data.textContent);
      const reviews = item.ReviewMetafields;
      delete item.ReviewMetafields;
      const queue = window._learnq = window._learnq || [];
      if (typeof queue.push !== 'function') return;
      productTracked = true;
      if (window.item == null) window.item = item;
      queue.push(['track', 'Viewed Product', item]);
      queue.push(['trackViewedItem', {
        Title: item.Name, ItemId: item.ProductID, Categories: item.Categories,
        ImageUrl: item.ImageURL, Url: item.URL,
        Metadata: { Brand: item.Brand, Price: item.Price, Value: item.Value, CompareAtPrice: item.CompareAtPrice },
        metafields: { reviews: reviews, yotpo: { rating: null, count: null }, loox: { rating: null, count: null }, okendo: { rating: null, count: null } }
      }]);
    } catch (_) {
      bootstrap.dataset.productState = 'unavailable';
    }
  }

  function cancelQuiet() {
    if (quietTimer !== null) clearTimeout(quietTimer);
    quietTimer = null;
    launchToken++;
    launchPending = false;
    if (mediaCleanup) mediaCleanup();
    mediaCleanup = null;
    if (idleHandle !== null && typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(idleHandle);
    if (idleTimer !== null) clearTimeout(idleTimer);
    idleHandle = null;
    idleTimer = null;
  }

  function stopStartupWork() {
    cancelQuiet();
    if (retryTimer !== null) clearTimeout(retryTimer);
    retryTimer = null;
    if (checkFrame !== null) cancelAnimationFrame(checkFrame);
    checkFrame = null;
    if (observer) observer.disconnect();
    if (privacyObserver) privacyObserver.disconnect();
    document.removeEventListener('focusin', onNewsletterIntent);
    document.removeEventListener('pointerdown', onNewsletterIntent);
    document.removeEventListener('submit', onNewsletterIntent);
    // Keep consent and page-state listeners after loading: withdrawal must still be handled.
  }

  function existingRuntime() {
    return sameCompanyScript();
  }

  function useExistingRuntime() {
    runtimeStarted = true;
    runtimeReady = true;
    stopStartupWork();
    state('existing', 'another-klaviyo-loader-present');
    trackProduct();
  }

  function start() {
    quietTimer = null;
    if (runtimeStarted || reloading) return;
    const reason = permissionToStart();
    if (reason) {
      waitedForPrivacy = true;
      cancelQuiet();
      state('waiting', reason);
      return;
    }
    if (existingRuntime()) { useExistingRuntime(); return; }
    stopStartupWork();
    state('loading');
    const script = document.createElement('script');
    script.id = 'nx-klaviyo-onsite-loader';
    script.async = true;
    script.src = SOURCE;
    script.addEventListener('load', function () {
      runtimeReady = true;
      if (reloading) return;
      if (!purposesAllowed()) { state('blocked', 'privacy-purpose-not-allowed'); return; }
      state('loaded');
      trackProduct();
    }, { once: true });
    script.addEventListener('error', function () {
      if (!reloading) state('error', 'klaviyo-network-error');
    }, { once: true });
    try {
      runtimeStarted = true;
      document.head.appendChild(script);
    } catch (_) {
      runtimeStarted = false;
      state('error', 'klaviyo-insertion-error');
    }
  }

  function startWhenIdle(token) {
    if (token !== launchToken || reloading || runtimeStarted) return;
    state('scheduled', 'mobile-idle');
    const launch = function () {
      if (token !== launchToken) return;
      start(); // Consent and page visibility are checked again immediately before insertion.
    };
    // Safari and a busy main thread both retain a bounded, cancellable fallback.
    idleTimer = setTimeout(launch, IDLE_WAIT_MS);
    if (typeof window.requestIdleCallback === 'function') {
      idleHandle = window.requestIdleCallback(launch, { timeout: IDLE_WAIT_MS });
    }
  }

  function afterQuiet() {
    quietTimer = null;
    if (!mobileStartup || newsletterRequested) { start(); return; }
    if (runtimeStarted || reloading) return;
    const token = ++launchToken;
    launchPending = true;
    // Wait only for the main still image. Product films load and autoplay independently.
    const image = document.querySelector('.nx-hero__image, [data-essence-poster], [data-anelo-poster], .nx-product__image.nx-image-selected');
    if (!image || image.complete) { startWhenIdle(token); return; }
    state('scheduled', 'main-image-loading');
    let timer = null;
    const cleanup = function () {
      image.removeEventListener('load', settled);
      image.removeEventListener('error', settled);
      if (timer !== null) clearTimeout(timer);
    };
    const settled = function () {
      cleanup();
      if (token !== launchToken) return;
      mediaCleanup = null;
      startWhenIdle(token);
    };
    mediaCleanup = cleanup;
    image.addEventListener('load', settled, { once: true });
    image.addEventListener('error', settled, { once: true });
    timer = setTimeout(settled, MAIN_IMAGE_WAIT_MS);
    if (image.complete) settled();
  }

  function onNewsletterIntent(event) {
    const target = event.target;
    if (!target || typeof target.closest !== 'function' || !target.closest('#nx-newsletter')) return;
    newsletterRequested = true;
    cancelQuiet();
    check();
  }

  function check() {
    if (reloading) return;
    const reason = permissionToStart();
    if (reason) {
      waitedForPrivacy = true;
      cancelQuiet();
      state(runtimeStarted ? 'blocked' : 'waiting', reason);
      return;
    }
    if (runtimeStarted) { trackProduct(); return; }
    if (existingRuntime()) { useExistingRuntime(); return; }
    if (quietTimer !== null || launchPending) return;
    state('scheduled');
    quietTimer = setTimeout(afterQuiet, newsletterRequested ? 0 : (waitedForPrivacy ? QUIET_MS : INITIAL_MS));
  }

  function queueCheck() {
    if (reloading || checkFrame !== null) return;
    checkFrame = requestAnimationFrame(function () {
      checkFrame = null;
      check();
    });
  }

  function onConsent() {
    if (reloading) return;
    waitedForPrivacy = true;
    cancelQuiet();
    // Already executed third-party code cannot be unloaded by deleting its script tag.
    // Reload once only after an explicit consent event withdraws a required purpose.
    if (runtimeStarted && !purposesAllowed()) {
      reloading = true;
      stopStartupWork();
      state('reloading', 'consent-withdrawn');
      setTimeout(function () { window.location.reload(); }, 0);
      return;
    }
    queueCheck();
  }

  function containsPrivacy(node) {
    return node && node.nodeType === 1 &&
      (Element.prototype.matches.call(node, PRIVACY_UI) || !!Element.prototype.querySelector.call(node, PRIVACY_UI));
  }

  function privacyMutation(record) {
    if (record.type === 'attributes') {
      return Element.prototype.matches.call(record.target, PRIVACY_UI) || privacyRoots.includes(record.target);
    }
    if (privacyRoots.some(root => !root.isConnected || root.contains(record.target))) return true;
    return Array.from(record.addedNodes).some(containsPrivacy) ||
      Array.from(record.removedNodes).some(containsPrivacy);
  }

  function watchPrivacy() {
    privacyObserver.disconnect();
    privacyRoots = Array.from(document.querySelectorAll(PRIVACY_UI));
    const ancestors = new Set();
    const attributes = { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'open'] };
    privacyRoots.forEach(root => {
      privacyObserver.observe(root, { ...attributes, subtree: true });
      for (let parent = root.parentElement; parent; parent = parent.parentElement) ancestors.add(parent);
    });
    ancestors.forEach(parent => {
      if (!privacyRoots.includes(parent)) privacyObserver.observe(parent, attributes);
    });
  }

  function probeApi() {
    retryTimer = null;
    if (runtimeStarted || reloading) return;
    bootstrap.dataset.apiAttempts = String(retryIndex + 1);
    if (!nativePrivacy() && !apiRequested && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      apiRequested = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          if (runtimeStarted || reloading) return;
          if (error) apiRequested = false;
          queueCheck();
        });
      } catch (_) {
        apiRequested = false;
      }
    }
    check();
    if (!runtimeStarted && !reloading && !nativePrivacy() && retryIndex < RETRY_MS.length) {
      retryTimer = setTimeout(probeApi, RETRY_MS[retryIndex++]);
    }
  }
  document.addEventListener('visitorConsentCollected', onConsent);
  document.addEventListener('visibilitychange', queueCheck);
  window.addEventListener('pageshow', queueCheck);
  document.addEventListener('focusin', onNewsletterIntent);
  document.addEventListener('pointerdown', onNewsletterIntent, { passive: true });
  document.addEventListener('submit', onNewsletterIntent);
  observer = new MutationObserver(function (records) {
    if (records.some(privacyMutation)) { watchPrivacy(); queueCheck(); }
  });
  privacyObserver = new MutationObserver(queueCheck);
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'id'] });
  watchPrivacy();
  state('initializing');
  probeApi();
})();

}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", startCoordinator, { once: true });
else startCoordinator();
})();
